import { useCallback, useLayoutEffect, useRef } from "react";

type TCb<A extends unknown[], R> = (...args: A) => R;

// https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
export const useEvent = <A extends unknown[], R>(
  callback: TCb<A, R>
): TCb<A, R> => {
  const handlerRef = useRef(callback);

  useLayoutEffect(() => {
    handlerRef.current = callback;
  });

  return useCallback((...args) => {
    return handlerRef.current(...args);
  }, []);
};
